import { createGlobalStyle } from 'styled-components';

import FDMSans400Woff2 from '../assets/fonts/dm-sans/DMSans-Regular.woff2';
import FDMSans600Woff2 from '../assets/fonts/dm-sans/DMSans-Medium.woff2';
import FDMSans700Woff2 from '../assets/fonts/dm-sans/DMSans-Bold.woff2';
import FInterWoff2 from '../assets/fonts/inter/inter-var-latin.woff2';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: DM Sans;
    src: url(${FDMSans400Woff2}) format('woff2');
    font-weight: normal;
    font-display: optional;
    font-style: normal;
  }
  @font-face {
    font-family: DM Sans;
    src: url(${FDMSans600Woff2}) format('woff2');
    font-weight: 600;
    font-display: optional;
    font-style: normal;
  }
  @font-face {
    font-family: DM Sans;
    src: url(${FDMSans700Woff2}) format('woff2');
    font-weight: 700;
    font-display: optional;
    font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
  font-style: normal;
  font-weight: 400 700; 
  font-display: optional;
  src: url(${FInterWoff2}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
  *, *:after, *:before{
  box-sizing: inherit;
  }
  ::selection {
    background-color: #47a3f3;
    color: #fefefe;
  }
  html {
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
    line-height: 1.5;
  }
  html, body, #root {
    height: 100%;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  }
  li {
    list-style: none;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  h1,h2,h3,h4,h5,h6,p {
    margin: 0
  }
`;
export default GlobalStyles;
